import * as Restaurant from './restaurant';
import * as SalesChannel from './salesChannel';

const Selectors = {
  Restaurant,
  SalesChannel
};

export default Selectors;
